import { render, staticRenderFns } from "./ProductMgmt.vue?vue&type=template&id=6a124ff2"
import script from "./ProductMgmt.vue?vue&type=script&lang=js"
export * from "./ProductMgmt.vue?vue&type=script&lang=js"
import style0 from "./ProductMgmt.vue?vue&type=style&index=0&id=6a124ff2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports